import { OnInit, Component, EventEmitter, Input, Output, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { first, Subscription } from "rxjs";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { BaseComponent } from "src/app/shared/base/base-component";
import { AlertService } from "src/app/alert-panel/alert.service";
import { SelectLocationPopupModel } from "src/app/_models/claimant-on-web/claimant-on-web";
import { ApiRequest, IApiresponse } from "src/app/_models";
import { LocationService } from "src/app/_services/location/location.service";
import { GetLocationByOrgIdAndStatusRequest, GetLocationShortDetailsResponse } from "src/app/_models/location/location";
import { environment } from "src/environments/environment";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";

@Component({
    selector: "select-location-panel",
    templateUrl: "./select-location-panel.component.html",
    standalone: false
})
export class SelectLocationPanelComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input()
    inputData: SelectLocationPopupModel;

    @Output() closePanelEvent = new EventEmitter<boolean>();
    @Output() selectItemEvent = new EventEmitter<SelectLocationPopupModel>();

    param: any;
    howDoIVideoLinks = HowDoIVideoLinks;
    searchText: string = '';
    hasFormChanges: boolean = false;

    userActionEventSubscription: Subscription;
    locationList = <GetLocationShortDetailsResponse[]>[];
    selectedLocationId: number = 0;
    isSelectionHide: boolean = false;
    disableSave: boolean= true;
    claims:Claims;
    locationLabel="Location";
    claimsSubscription: Subscription;

    constructor(private alertService: AlertService,private claimsService:ClaimsService,
        private locationService: LocationService, private cdr:ChangeDetectorRef) {
        super();
        this.claimsSubscription = this.claimsService.currentClaims.subscribe(
            (claims) => {
              this.claims = claims;
              this.locationLabel= this.claims.LocationLabel??'Location';
            }
          );

        this.userActionEventSubscription = this.alertService.getUserActionEvent().subscribe(action => {
            if (action) {
                this.closePanelEvent.emit(true);
            }
        });
    }
    ngOnInit(): void {
        this.fnGetActiveLocationList();
        this.fnSetLocationInputValues();
    }

    canDeactivate(): boolean {
        return !this.hasFormChanges;
    }

    ngOnDestroy() {
        this.userActionEventSubscription.unsubscribe();
    }

    fnClosePanel() {
        if (this.canDeactivate()) {
            this.closePanelEvent.emit(true);
        }
        else {
            this.alertService.onFormClosed();
        }
    }

    fnGetActiveLocationList() {
        let request = new ApiRequest<GetLocationByOrgIdAndStatusRequest>(
            "GetActiveLocations",
            environment.applicationVersion,
            environment.requestId
          );
          let requestInfo = new GetLocationByOrgIdAndStatusRequest();
          requestInfo.organisationId = this.claims.OrgId;
          requestInfo.status = 1;
      
          request.requestInfo = requestInfo;
      
          this.locationService
            .GetActiveLocations(request)
            .pipe(first())
            .subscribe(
              (response: IApiresponse<GetLocationShortDetailsResponse[]>) => {
                if (response.responseInfo != null) {
                  for (let index = 0; index < response.responseInfo.length; index++) {
                    const element = response.responseInfo[index];
                    element.nameCode =
                      element.locationName + " - " + element.locationCode1;
                  }
                  this.locationList = response.responseInfo;
                  this.cdr.detectChanges();
                }
              }
            );
    }

    fnSelectLocation() {
        
        let selectLoOutputModel = new SelectLocationPopupModel();
        if (this.selectedLocationId > 0) {
            let locationDetails = this.locationList.find(item => item.locationId == this.selectedLocationId);
            if (locationDetails) {
                selectLoOutputModel.locationId = locationDetails.locationId;
                selectLoOutputModel.locationName = locationDetails.locationName;
            }
        } else {
            selectLoOutputModel.locationId = 0;
            selectLoOutputModel.locationName = '';
        }
        this.selectItemEvent.emit(selectLoOutputModel);
    }

    fnOnChangeLocation(locationId: number) {
        if (locationId == this.selectedLocationId) {
            this.selectedLocationId = 0;
        } else {
            this.selectedLocationId = locationId;
        }

        //enabled / disabled save button
        if(this.isSelectionHide){
            if(!this.selectedLocationId){
                this.disableSave = true;
            }
            else{
                this.disableSave = false;
            }
        }       
        else{
            this.disableSave = false;
        }
    }

    fnSetLocationInputValues() {
        if (this.inputData) {
            this.selectedLocationId = this.inputData.locationId;
            this.isSelectionHide = this.inputData.isSelectionHide;
        }
    }
    fnGetSelectedLocationOnTop() {
        let locationId = this.inputData && this.inputData.locationId ? this.inputData.locationId : 0;

        if (locationId && this.locationList && this.locationList.length > 0) {
            const sortedArr = this.locationList.reduce((acc, element) => {
                if (element.locationId  == locationId) {
                    return [element, ...acc];
                }
                return [...acc, element];
            }, []);
            this.locationList = sortedArr;
        }
    }
}
